// queries/useGetImagePrompt.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { GET_IMAGE_PROMPT } from "api";
import { fetch } from "libs";
import { Prompt } from "types";

function fetchOptions(fileName: string, isFlux: boolean): Promise<Prompt> {
  return fetch(`${GET_IMAGE_PROMPT(fileName)}?is_flux=${isFlux}`, {
    method: "GET",
  });
}

export default function usePromptOptions(fileName: string, isFlux: boolean = false, opts = {}) {
  return useQuery<Prompt, Error>({
    queryKey: ["getPromptOptions", fileName, isFlux],
    queryFn: () => fetchOptions(fileName, isFlux),
    enabled: !!fileName,
    retry: false,
    ...opts,
  });
}